import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import SearchBox from "../../AdminComponents/Common/SearchBox";
import PaginationDataTable from "../../AdminComponents/Common/PaginationDataTable";
import { useNavigate } from "react-router-dom";
import Heading from "../../AdminComponents/Common/Heading";
import { BASE_URL } from "../../Assets/Constants";
import { formatDate } from "../../Services/dymmyData";
import { theme } from "../../Assets/Theme/theme";

function Payments() {
  const [paymentsData, setPaymentsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  const columns = [
    { id: "S.no", name: "S.no" },
    { id: "user", name: "User" },
    { id: "date", name: "Date" },
    { id: "amount", name: "Amount" },
    { id: "status", name: "Status" },
  ];

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/admin/payments`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const rowsData = response?.data?.data?.map((item, index) => ({
          sNo: index + 1,
          user: item.user?.user || 'Undefined',
          date: formatDate(item.createdAt),
          amount: item.total,
          status: item.status,
          currency: item.currency,
          action: null,
          _id: item._id,
        }));
        setPaymentsData(rowsData);
        setFilteredData(rowsData);
      } catch (error) {
        if (error.response?.status === 401 || error.message.includes("Authentication")) {
          navigate("/login");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  const [currentPage, setCurrentPage] = useState(0);

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchQuery(value);
    setCurrentPage(0); 
    const filtered = paymentsData.filter((item) =>
      item.user?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };
  

  return (
    <Box>
      <Heading label={"Payments"} />
      <Box mt={4}>
        <SearchBox
          placeholder={"Search by user"}
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </Box>
      <Box>
        {loading ? (
          <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", 
          }}
        >
          <CircularProgress size={30} sx={{ color: theme.colors.orange }} />
        </Box>
        ) :  (
          <PaginationDataTable
            editAndDelete={true}
            columns={columns}
            rows={filteredData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ) }
      </Box>
    </Box>
  );
}

export default Payments;
